module.exports = __webpack_public_path__ + "img/ranking-finished.73bfe197.png";